<template>
  <div>
    <el-dialog
      title="团员人数"
      :visible.sync="dialogVisible"
      width="1080px"
      :before-close="handleClose"
    >
      <div class="dl-page">
        <div class="search-layout">
          <div class="item-wrap">
            <el-input
              size="small"
              placeholder="业务人员ID"
              v-model="formIn.salesJobNumber"
            />
          </div>
          <div class="item-wrap op">
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch">
              搜索
            </el-button>
          </div>
        </div>
        <div class="table-wrap">
          <MyTable
            :table-data="tableData"
            :index="index"
            :selection="selection"
            :page="page"
            :operation="false"
            :table-option.sync="tableOption"
            @page-change="getList"
          >
          </MyTable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="right">
          <el-button @click="handleClose" size="small">取 消</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";

import { getSalesUserMemberInformationBySalesIdPage } from "@/api/externalSalesRule/index.js";
import _ from "lodash";

export default {
  components: { MyTable },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      rowData: null,

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "业务人员ID", prop: "salesJobNumber", minWidth: 120 },
        { label: "业务人员手机号", prop: "contactInformation", minWidth: 120 },
        { label: "业务区域", prop: "serviceArea", minWidth: 160 },
        {
          label: "客户数量",
          prop: "numberCustomers",
          minWidth: 120,
        },
        {
          label: "接品数量",
          prop: "inoculationQuantity",
          minWidth: 120,
        },
        {
          label: "团员人数",
          prop: "numberMembers",
          minWidth: 120,
        },
        { label: "邀请人ID", prop: "invitationNumber", minWidth: 120 },
        { label: "上月预估", prop: "lastMonthEstimateAmount", minWidth: 120 },
        { label: "本月预估", prop: "thisMonthEstimateAmount", minWidth: 120 },
        { label: "注册时间", prop: "registerTime", minWidth: 160 },
        {
          label: "最后访问时间",
          prop: "lastAccessTime",
          minWidth: 160,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },
      dialogVisible: false,
      formIn: {
        salesJobNumber: "",
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    resetForm() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    getList() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        salesUserId: this.rowData.id,
      };
      _.merge(params, this.formIn);

      getSalesUserMemberInformationBySalesIdPage(params).then((data) => {
        if (data) {
          const { records, total } = data;
          this.page.total = total;
          this.tableData = records;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }

      this.rowData = null;
      this.tableData = [];
    },
    open(row) {
      this.clear();
      this.dialogVisible = true;
      this.rowData = _.cloneDeep(row);

      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 4em;
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
